/* MYNTELO 3D hero boot v5.6 (v5.0 boot + Galaxy, 2026-10-15). data-family='galaxy' on the root = a Samsung Galaxy case page: Model values are the engine's Galaxy keys (the exact Shopify option strings), the model fallback never crosses families (an iPhone page ignores Galaxy models and vice versa), Wallet / Grip hide on the closed Z Flip 8 (the pieces do not fit the slab). root._m3dSwap({family, handle, model, design, designHi, poster, legal, wordmark, wordmarkB, wordmarkW}) re-targets the SAME stage to another product (the homepage device switch uses it: iPhone <-> Galaxy twin in place, before or after the engine has mounted). data-wordmark='b'|'w' + data-wordmark-b / data-wordmark-w (transparent MYNTELO PNGs) = compose the wordmark onto the prepared texture before it reaches the engine (lower centre, the Podbase phone position: cx 1023, baseline 2971, 497 px wide in the 2048x3482 texture); off unless the liquid asks, because the store's m3d-tex files already carry the wordmark since the 2026-10-14 rollout. */ /* MYNTELO 3D hero boot v5.0 (v4.2 boot unchanged in behaviour; data-screen-style='bw'|'wb' on the root picks the neutral white / black lock screen (engine opt `screen`), default = the mint lock screen; ships with engine v5.0: natural idle turntable, weighty throw, seamless poster entrance, island double-tap, monochrome stage UI in myntelo-3d-hero.liquid). v4.2 (v4.1 + one stage, phones AND garments: data-meshes on the root registers GLB garments (JSON {name:{url,height,roughness,env}}); root._m3dShowMesh(name) / root._m3dShowPhone() switch the same stage between a garment and the phone (the homepage carousel uses this for the crewneck panel). In garment mode the phone-only UI (colours, accessories, legal line) hides via .m3d--mesh and Front/Back swap labels, because the engine's cameras are phone-named and a garment's print faces the engine's back camera. data-glb on the root (the old drop hero) = a garment-only stage). v4.1 (v4.0 + mesh models). v4.0 (v3.6 + textures in two steps: 1024 first, the 2048 master handed to the engine as an upgrade it takes when worth it; #debug or ?debug shows the engine overlay). v3.6: (accessories: m3d:accessory {picked:[...], changed, quiet} from the Complete the set rows says which pieces are in the set; the Wallet / Grip buttons under the stage choose which one is on the phone, the other ticked piece stands beside it; data-acc on the root = try-on mode for accessory pages; the printed face comes from the accessory's own Podbase photo). Loads the engine and three.js (in parallel, engine first so its texture worker starts early) only when the hero is on screen and the poster has painted, then mounts. Design source, in order: data-design (prepared texture), data-print (raw Canva print file, placed like Podbase does), data-mockup (photo). v3.2: exposes root._m3dSetModel / root._m3dDesign and fires m3d:ready so a host (the homepage remix) can drive one shared stage; data-m3d-lazy=view skips the idle preload; data-source tags analytics. */
(function(){
  var loading={};
  var TEX={w:1024,h:1741,cx:511.5,cy:870,pw:939,ph:1684};
  // Wordmark on the printed back, as fractions of the 2048x3482 texture: centre x 1023, baseline 2971, width 497 px (26 mm at 19.11 px/mm; the rollout's Podbase phone placement).
  var WM={cx:1023/2048, base:2971/3482, w:497/2048};
  var LEGAL={iphone:'Live 3D preview on a generic phone model. iPhone is a trademark of Apple Inc.', galaxy:'Live 3D preview on a generic phone model. Samsung and Galaxy are trademarks of Samsung Electronics Co., Ltd.'};
  function loadImg(src){ return new Promise(function(res, rej){ var im=new Image(); im.crossOrigin='anonymous'; im.onload=function(){ res(im); }; im.onerror=function(){ rej(new Error('image '+src)); }; im.src=src; }); }
  // Texture + wordmark PNG (bottom edge of the PNG = the baseline) -> canvas at the texture's own size (1024 or 2048 wide).
  function stamp(img, wm){
    var c=document.createElement('canvas'); c.width=img.naturalWidth; c.height=img.naturalHeight;
    var g=c.getContext('2d'); g.imageSmoothingQuality='high'; g.drawImage(img, 0, 0);
    var W=c.width*WM.w, H=W*wm.naturalHeight/wm.naturalWidth;
    g.drawImage(wm, c.width*WM.cx-W/2, c.height*WM.base-H, W, H);
    return c;
  }
  function script(src){
    if(loading[src]) return loading[src];
    loading[src]=new Promise(function(res, rej){ var s=document.createElement('script'); s.src=src; s.async=false; s.onload=res; s.onerror=rej; document.head.appendChild(s); });
    return loading[src];
  }
  function track(root){
    var d={product:root.dataset.handle||'', source:root.dataset.source||'product'};
    try{ (window.dataLayer=window.dataLayer||[]).push({event:'myntelo_3d_interact', product:d.product, source:d.source}); }catch(e){}
    try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('myntelo_3d_interact', d); }catch(e){}
  }
  function trackAcc(root, type){
    var d={product:root.dataset.handle||'', source:root.dataset.source||'product', accessory:type||'none'};
    try{ (window.dataLayer=window.dataLayer||[]).push({event:'myntelo_3d_accessory', product:d.product, source:d.source, accessory:d.accessory}); }catch(e){}
    try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('myntelo_3d_accessory', d); }catch(e){}
  }
  // Where the printed face sits in the Podbase accessory photos (1200 px square template): crop x, y, w, h, canvas size, then two points that must be dark.
  var ART={wallet:[431,473,346,543,512,804,[[404,700],[600,300]]], grip:[276,276,648,648,512,512,[[228,600],[972,600]]]};
  function cropArt(im, type){
    var a=ART[type], S=im.naturalWidth;
    if(!a || !S || S!==im.naturalHeight) return null;
    var t=document.createElement('canvas'); t.width=t.height=300;
    var tg=t.getContext('2d'); tg.drawImage(im, 0, 0, 300, 300);
    var d=tg.getImageData(0, 0, 300, 300).data;
    var lum=function(x, y){ var p=(Math.round(y/4)*300+Math.round(x/4))*4; return (d[p]+d[p+1]+d[p+2])/3; };
    if(lum(a[6][0][0], a[6][0][1])>120 || lum(a[6][1][0], a[6][1][1])>120 || lum(70, 70)<235) return null;
    var c=document.createElement('canvas'); c.width=a[4]; c.height=a[5];
    var g=c.getContext('2d'), k=S/1200; g.imageSmoothingQuality='high';
    g.drawImage(im, a[0]*k, a[1]*k, a[2]*k, a[3]*k, 0, 0, c.width, c.height);
    return c;
  }
  // Raw print file -> design texture, placed like Podbase does (cover the print area, centred). k=2 for files wider than 1200 px.
  function compose(img){
    var w=img.naturalWidth, h=img.naturalHeight;
    if(!w || !h) return null;
    var k=w>1200?2:1, W, H;
    if(w/h>=TEX.pw/TEX.ph){ H=TEX.ph*k; W=w*H/h; } else { W=TEX.pw*k; H=h*W/w; }
    var c=document.createElement('canvas'); c.width=TEX.w*k; c.height=TEX.h*k;
    var g=c.getContext('2d'); g.imageSmoothingQuality='high';
    g.drawImage(img, 0, 0, c.width, c.height);
    g.drawImage(img, TEX.cx*k-W/2, TEX.cy*k-H/2, W, H);
    return c;
  }
  function design(root, hero){
    var d=root.dataset;
    var mockup=function(){ hero.setDesign(d.mockup,{mockup:true}); };
    if(d.design){
      var wmSrc=d.wordmark==='w' ? d.wordmarkW : d.wordmark==='b' ? d.wordmarkB : '';
      var plain=function(){ hero.setDesign(d.design, d.designHi && d.designHi!==d.design ? {hi:d.designHi} : null); };
      if(!wmSrc){ plain(); return; }
      var src=d.design, hiSrc=d.designHi && d.designHi!==d.design ? d.designHi : '';
      Promise.all([loadImg(src), loadImg(wmSrc)]).then(function(r){
        if(root.dataset.design!==src || root.dataset.wordmark!==d.wordmark) return;
        var c=stamp(r[0], r[1]);
        hero.setDesign('wm'+d.wordmark+':'+src, {canvas:c, hi:hiSrc ? function(done){
          loadImg(hiSrc).then(function(im){ var c2=null; try{ c2=stamp(im, r[1]); }catch(e){} done(c2); }, function(){ done(null); });
        } : null});
      }, function(){ if(root.dataset.design===src) plain(); });
      return;
    }
    if(!d.print){ mockup(); return; }
    var src=d.print, hiSrc=d.printHi && d.printHi!==d.print ? d.printHi : '';
    var img=new Image(); img.crossOrigin='anonymous';
    img.onload=function(){
      if(root.dataset.print!==src) return;
      try{
        var c=compose(img);
        if(!c){ mockup(); return; }
        hero.setDesign('print:'+src, {canvas:c, hi:hiSrc ? function(done){
          var im2=new Image(); im2.crossOrigin='anonymous';
          im2.onload=function(){ var c2=null; try{ c2=compose(im2); }catch(e){} done(c2); };
          im2.onerror=function(){ done(null); };
          im2.src=hiSrc;
        } : null});
      }catch(e){ mockup(); }
    };
    img.onerror=mockup;
    img.src=src;
  }
  // Re-target a root to another product: data-* for the next mount, legal line and poster now, and the live stage if the engine is up.
  var SWAP=['family','handle','source','model','design','designHi','print','printHi','mockup','poster','wordmark','wordmarkB','wordmarkW'];
  function swap(root, cfg){
    cfg=cfg||{};
    SWAP.forEach(function(k){ if(k in cfg){ if(cfg[k]===null || cfg[k]===undefined || cfg[k]==='') delete root.dataset[k]; else root.dataset[k]=String(cfg[k]); } });
    var legal=root.querySelector('.m3d__legal'); if(legal) legal.textContent=cfg.legal || LEGAL[root.dataset.family||'iphone'] || LEGAL.iphone;
    var poster=root.querySelector('[data-m3d-poster]');
    if(poster && cfg.poster){ poster.removeAttribute('srcset'); poster.removeAttribute('sizes'); poster.src=cfg.poster; poster.classList.toggle('m3d__poster--render', !!cfg.posterRender); }
    if(root._m3dApply) root._m3dApply(cfg);
  }
  function meshList(root){
    var list={};
    try{ if(root.dataset.meshes) list=JSON.parse(root.dataset.meshes)||{}; }catch(e){ list={}; }
    if(root.dataset.glb) list[root.dataset.model||'mesh']={url:root.dataset.glb, height:parseFloat(root.dataset.glbHeight)||160, roughness:root.dataset.glbRough?parseFloat(root.dataset.glbRough):undefined, env:root.dataset.glbEnv?parseFloat(root.dataset.glbEnv):undefined};
    return list;
  }
  function mount(root){
    var M=window.Myntelo3D;
    if(root.dataset.m3dReady || !window.THREE || !M || !M.supported()) return;
    root.dataset.m3dReady='1';
    var stage=root.querySelector('.m3d__stage'), canvas=root.querySelector('.m3d__canvas'), sw=root.querySelector('[data-m3d-swatches]'), nameEl=root.querySelector('[data-m3d-color-name]'), input=root.querySelector('[data-m3d-input]'), spinBtn=root.querySelector('[data-m3d-spin]');
    var meshes=meshList(root), fixedMesh=!!root.dataset.glb;
    if(M.registerMesh) Object.keys(meshes).forEach(function(k){ var m=meshes[k]||{}; if(m.url) M.registerMesh(k,{url:m.url, loader:m.loader||root.dataset.gltfloader, height:m.height||160, roughness:m.roughness, envMapIntensity:m.env, shadowW:m.shadowW, shadowD:m.shadowD}); });
    function meshName(v){ return !!(v && M.MESH && M.MESH[v]); }
    /* Mount on the model the page's Model picker currently shows when it belongs to this root's family (the device script or the home card's
       device switch may have moved the dropdown before this script arrived); otherwise data-model, and never a model of the other family. */
    (function(){
      var f=root.dataset.family||'iphone', ok=function(v){ var m=v && M.MODELS[v]; return !!m && (m.family||'iphone')===f; };
      if(meshName(root.dataset.model)) return;
      var scope=root.closest('.product, section, .shopify-section')||document, sel=scope.querySelector('variant-selects select, variant-radios input:checked, select[name^="options"]');
      var cur=sel && sel.value;
      if(ok(cur)) root.dataset.model=cur;
      else if(!ok(root.dataset.model)){ for(var k in M.MODELS) if(ok(k)){ root.dataset.model=k; break; } }
    })();
    var startMesh=meshName(root.dataset.model);
    var lastPhone=startMesh ? (root.dataset.phoneModel||'') : root.dataset.model, lastColor=null;
    function famOf(v){ var m=v && M.MODELS[v]; return m ? (m.family||'iphone') : null; }
    function family(){ return root.dataset.family||'iphone'; }
    function firstModel(){ var f=family(), v=root.dataset.model; if(famOf(v)===f) return v; for(var k in M.MODELS) if(famOf(k)===f) return k; return 'iPhone 17 Pro'; }
    function isFlip(){ var m=M.MODELS[hero.model()]; return !!(m && m.front && m.front.flip); }
    var hero=M.mount(canvas,{model:root.dataset.model, logo:root.dataset.logo||null, screen:root.dataset.screenStyle||null, waitDesign:true,
      onInteract:function(){ root.classList.add('m3d--touched'); if(spinBtn) spinBtn.setAttribute('aria-pressed','false'); track(root); },
      onDesign:function(){ root.classList.add('m3d--live'); },
      onReady:function(){ if(isMesh()) root.classList.add('m3d--live'); },
      onError:function(){ root.classList.remove('m3d--live'); }});
    function isMesh(){ return meshName(hero.model()); }
    /* The engine's view cameras are named for a phone (front = screen). A garment's print faces the engine's "back" camera, so the labels swap in garment mode. */
    var viewBtns={front:root.querySelector('[data-m3d-view="front"]'), back:root.querySelector('[data-m3d-view="back"]')};
    function labels(mesh){
      ['front','back'].forEach(function(k){
        var b=viewBtns[k]; if(!b) return;
        if(!b.dataset.label) b.dataset.label=b.textContent;
        var other=viewBtns[k==='front'?'back':'front'];
        b.textContent=mesh && other ? (other.dataset.label||other.textContent) : b.dataset.label;
      });
    }
    /* Garment GLBs load on demand: keep the poster up until the garment is on the stage. */
    function whenLoaded(name, done){
      var t0=Date.now();
      (function poll(){
        var m=M.MESH && M.MESH[name];
        if(!m || hero.model()!==name) return;
        if(!m.loading || Date.now()-t0>20000){ done(); return; }
        setTimeout(poll, 120);
      })();
    }
    function swatches(){
      var cw=root.querySelector('.m3d__colors');
      if(isMesh()){ if(sw) sw.textContent=''; if(cw) cw.hidden=true; return; }
      if(!sw) return;
      var sel=hero.color(); sw.textContent='';
      hero.colors().forEach(function(c){
        var b=document.createElement('button'); b.type='button'; b.className='m3d__sw'; b.style.background=c[1]; b.title=c[0];
        b.setAttribute('aria-label',c[0]); b.setAttribute('aria-pressed',String(c[0]===sel[0]));
        b.addEventListener('click',function(){ hero.setColor(c[0]); if(input){ input.disabled=false; input.value=c[0]+' '+hero.model(); } swatches(); });
        sw.appendChild(b);
      });
      if(nameEl) nameEl.textContent=sel[0];
      if(input && !input.disabled) input.value=sel[0]+' '+hero.model();
      if(cw) cw.hidden=false;
    }
    if(startMesh){ root.classList.add('m3d--mesh'); labels(true); }
    else design(root, hero);
    swatches();
    root.querySelectorAll('[data-m3d-view]').forEach(function(b){ b.addEventListener('click',function(){ hero.view(b.dataset.m3dView); if(spinBtn) spinBtn.setAttribute('aria-pressed','false'); }); });
    root.querySelectorAll('[data-m3d-zoom]').forEach(function(b){ b.addEventListener('click',function(){ hero.zoom(Number(b.dataset.m3dZoom)); }); });
    if(spinBtn) spinBtn.addEventListener('click',function(){ var on=spinBtn.getAttribute('aria-pressed')!=='true'; hero.spin(on); spinBtn.setAttribute('aria-pressed',String(on)); });
    function model(v){
      if(!v || !M.MODELS[v] || famOf(v)!==family()) return;   // a Galaxy page never shows an iPhone and vice versa
      if(isMesh()){ lastPhone=v; return; }   // a garment is on the stage: remember the phone for when the visitor goes back
      if(v!==hero.model()){ hero.setModel(v); swatches(); if(root._m3dAccPaint) root._m3dAccPaint(); }
    }
    document.addEventListener('change',function(e){ model(e.target && e.target.value); });
    try{ if(window.subscribe) window.subscribe('variant-change', function(ev){ var v=ev && ev.data && ev.data.variant; if(v && v.option1) model(v.option1); }); }catch(e){}
    root._m3d=hero;
    root._m3dSetModel=model;
    root._m3dDesign=function(){ if(!isMesh()) design(root, hero); };
    root._m3dApply=function(cfg){
      var v=(cfg && cfg.model) || root.dataset.model;
      if(famOf(v)!==family()) v=firstModel();
      if(isMesh()){ lastPhone=v; return; }
      if(v!==hero.model()) hero.setModel(v);
      swatches(); design(root, hero);
      if(root._m3dAccRefresh) root._m3dAccRefresh();
    };
    root._m3dShowMesh=function(name){
      if(fixedMesh || !meshName(name)) return;
      if(!isMesh()){ lastPhone=hero.model(); lastColor=hero.color(); }
      if(hero.model()===name) return;
      if(hero.accessory) try{ hero.accessory(null, true); }catch(e){}
      root.classList.add('m3d--mesh'); labels(true);
      var m=M.MESH[name], cached=m && m._seen;
      if(!cached) root.classList.remove('m3d--live');
      hero.setModel(name); swatches();
      whenLoaded(name, function(){ if(m) m._seen=1; root.classList.add('m3d--live'); });
    };
    root._m3dShowPhone=function(v){
      if(fixedMesh || !isMesh()) return;
      root.classList.remove('m3d--mesh'); labels(false);
      hero.setModel(v && famOf(v)===family() ? v : (famOf(lastPhone)===family() ? lastPhone : firstModel()));
      if(lastColor) try{ hero.setColor(lastColor[0]); }catch(e){}
      swatches(); design(root, hero);
      root.classList.add('m3d--live');
      if(root._m3dAccRefresh) root._m3dAccRefresh();
    };
    if(hero.accessory && !fixedMesh){
      var d0=root.dataset, art={}, artGen=0, seq=0, picked={}, on=null, boxes=[];
      var btns=[].slice.call(root.querySelectorAll('[data-m3d-acc]')), bar=root.querySelector('[data-m3d-accbar]'), note=root.querySelector('[data-m3d-accnote]');
      var label={wallet:'Magnetic Wallet', grip:'Magnetic Grip'};
      var box=function(t){ return boxes.filter(function(b){ return b.dataset.name===t; })[0]; };
      var other=function(t){ return t==='wallet' ? 'grip' : 'wallet'; };
      root._m3dAccessory=function(t, quiet, side){ return hero.accessory(t, quiet, side); };
      var loadArt=function(type){
        if(!type) return Promise.resolve();
        if(art[type]) return art[type];
        var b=box(type), src=d0['art'+type.charAt(0).toUpperCase()+type.slice(1)] || (b && b.dataset.art);
        if(!src) return art[type]=Promise.resolve();
        var gen=artGen;
        return art[type]=new Promise(function(res){
          var im=new Image(); im.crossOrigin='anonymous';
          im.onload=function(){ try{ var c=gen===artGen && cropArt(im, type); if(c) hero.accessoryArt(type, c); }catch(e){} res(); };
          im.onerror=res; setTimeout(res, 2500); im.src=src;
        });
      };
      var paint=function(){
        var both=!!(picked.wallet && picked.grip), n=0, msg='';
        btns.forEach(function(b){
          var t=b.dataset.m3dAcc, have=!!box(t) && !isFlip();
          b.hidden=!have; if(have) n++;
          b.setAttribute('aria-pressed', String(on===t)); b.classList.toggle('is-set', !!picked[t]);
        });
        if(bar) bar.hidden=!n;
        root.classList.toggle('m3d--both', both);
        if(note && !d0.acc){
          if(both) msg='Both are in your set. Tap Wallet or Grip to swap which one is on the phone.';
          else if(on && !picked[on]) msg='Just a preview. Tick '+label[on]+' below to add it to your order.';
          note.textContent=msg; note.hidden=!msg;
        }
      };
      var show=function(quiet){
        var s=++seq, side=on && picked[other(on)] ? other(on) : null, was=hero.accessory();
        paint();
        if(isMesh()) return;
        if(isFlip()){ if(was) hero.accessory(null, true); return; }   // the closed Z Flip 8 is a slab: no wallet / grip on it
        Promise.all([loadArt(on), loadArt(side)]).then(function(){
          if(s!==seq || isMesh()) return;
          hero.accessory(on, quiet, side);
          if(on!==was && !quiet) trackAcc(root, on);
        });
      };
      document.addEventListener('m3d:accessory', function(e){
        var d=e.detail||{}, c=d.changed;
        picked={}; (d.picked||[]).forEach(function(t){ picked[t]=1; });
        if(c && picked[c]) on=c;
        else if(on && !picked[on] && (c===on || !c)) on=picked[other(on)] ? other(on) : null;
        else if(!on && !c) on=picked.wallet ? 'wallet' : picked.grip ? 'grip' : null;
        show(d.quiet);
      });
      btns.forEach(function(b){
        var t=b.dataset.m3dAcc;
        b.addEventListener('click', function(){
          if(on===t){ if(picked[t]) return; on=null; } else on=t;
          if(spinBtn) spinBtn.setAttribute('aria-pressed','false');
          show(false);
        });
        var want=function(){ loadArt(t); };
        b.addEventListener('pointerenter', want); b.addEventListener('focus', want);
      });
      var scan=function(){
        boxes=[].slice.call(document.querySelectorAll('[data-mx-set] .mx-set__check[data-art]'));
        picked={};
        boxes.forEach(function(b){
          if(b.checked) picked[b.dataset.name]=1;
          if(b._m3dWired) return; b._m3dWired=1;
          var row=b.closest('label')||b, want=function(){ loadArt(b.dataset.name); };
          row.addEventListener('pointerenter', want); row.addEventListener('touchstart', want, {passive:true}); b.addEventListener('focus', want);
        });
        if((boxes.length || d0.acc) && !isMesh()) hero.accessoryPrep();
        on=d0.acc || (picked.wallet ? 'wallet' : picked.grip ? 'grip' : null);
      };
      root._m3dAccRefresh=function(){ art={}; artGen++; scan(); show(true); };
      root._m3dAccPaint=function(){ show(true); };
      scan();
      paint();
      if(on) show(true);
    }
    try{ root.dispatchEvent(new CustomEvent('m3d:ready',{bubbles:true})); }catch(e){}
  }
  function start(root){
    if(root.dataset.m3dStarted) return; root.dataset.m3dStarted='1';
    var poster=root.querySelector('[data-m3d-poster]');
    var painted=new Promise(function(res){ if(!poster || poster.complete) return res(); poster.addEventListener('load',res); poster.addEventListener('error',res); setTimeout(res, 1200); });
    painted.then(function(){ var e=script(root.dataset.engine), t=script(root.dataset.three); return Promise.all([e, t]); }).then(function(){ mount(root); }).catch(function(){ root.classList.remove('m3d--live'); });
  }
  function boot(scope){
    (scope||document).querySelectorAll('[data-m3d]').forEach(function(root){
      if(!root._m3dSwap) root._m3dSwap=function(cfg){ swap(root, cfg); };
      if(root.dataset.m3dStarted) return;
      if(window.IntersectionObserver){
        var io=new IntersectionObserver(function(en){ if(en[0].isIntersecting){ io.disconnect(); start(root); } }, {rootMargin:'600px 0px'});
        io.observe(root);
        if(root.dataset.m3dLazy!=='view'){
          var idle=window.requestIdleCallback || function(f){ return setTimeout(f, 2500); };
          idle(function(){ if(!root.dataset.m3dStarted){ io.disconnect(); start(root); } }, {timeout:4000});
        }
      } else start(root);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ boot(); }); else boot();
  document.addEventListener('shopify:section:load',function(e){ boot(e.target); });
})();
